import * as localforage from 'localforage';
import LogName from './logname';
import { query, mutation } from './graphql/graphql';
import { currentDate } from './utils/helpers';

/**
 * LoggerStorage
 */
export class LoggerStorage extends LogName {
  localForage = null;

  apollo = null;

  logName = null;

  storage = {
    token: null,
    uf: null,
    home: false,
  };

  report = {
    canal_id: null,
    url: null,
    uf_id: null,
    uf_sigla: null,
    noticia_id: null,
    titulo: null,
    so: null,
    ip: null,
    navegador: null,
    acao: 'navegacao',
  };

  /**
   * Initial localforage
   */
  constructor(apollo) {
    super();
    localforage.config({
      driver: localforage.INDEXEDDB,
      name: 'logger.revista',
    });
    // Instance Apollo
    this.apollo = apollo;

    this.clearLogger(currentDate())
      .then(r => r)
      .catch(e => console.log(e));
  }

  /**
   * get access
   * @param to
   * @returns {null|{path: *, report: string, slug: *}|{path: *, report: string}}
   */
  getPageAccess(to) {
    const { name, params, path } = to;
    switch (name) {
      case 'home':
        return { report: 'home', path, gql: false };
      case 'categoria':
        return {
          report: 'categoria',
          slug: params.categoria,
          path,
          gql: true,
        };
      case 'post':
        return {
          report: 'post',
          slug: params.noticia,
          path,
          gql: true,
        };
      default:
        return null;
    }
  }

  startLogger(report, to) {
    const access = this.getPageAccess(to);
    if (access) {
      if (access.gql) {
        this.createLoggerPages(report, to, access)
          .then(res => {
            // Create LogName
            this.logName = `${currentDate()}.${res.noticia_id}.${report.uf}.${report.token}`;

            this.report.canal_id = report.canal.id;
            this.report.url = to.fullPath;
            this.report.uf_id = report.uf_id;
            this.report.uf_sigla = report.uf;
            this.report.noticia_id = res.noticia_id;
            this.report.titulo = res.titulo;
            this.report.so = report.navigator.platform;
            this.report.ip = report.ipAddress;
            this.report.navegador = report.navigator.userAgent;
            this.createStorageLogger(report, this.report);
          })
          .catch(e => console.log(e));
      } else if (access.report === 'home') {
        this.logName = `${currentDate()}.home.${report.uf}.${report.token}`;
        this.report.canal_id = report.canal.id;
        this.report.url = to.fullPath;
        this.report.uf_id = report.uf_id;
        this.report.uf_sigla = report.uf;
        this.report.so = report.navigator.platform;
        this.report.ip = report.ipAddress;
        this.report.navegador = report.navigator.userAgent;
        this.createStorageLogger(report, this.report);
      }
    }
  }

  createLoggerPages(report, to, access) {
    return new Promise((resolve, reject) => {
      if (access.report === 'post') {
        query(this.apollo, access.report, {
          modulo: report.modulo,
          canal: report.canal.id,
          slug: access.slug,
          uf: [report.uf],
        })
          .then(({ data }) => {
            const [logger] = data.data.response;
            if (logger) {
              const _report = {};
              const { id, titulo } = logger;
              _report.noticia_id = id;
              _report.titulo = titulo;
              resolve(_report);
            } else reject(true);
          })
          .catch(e => reject(e));
      } else reject(true);
    });
  }

  async createStorageLogger({ token, uf }, report) {
    const { storage } = this;
    if (storage.token === null || storage.token !== token) storage.token = token;
    if (storage.uf === null || storage.uf !== uf) storage.uf = uf;

    const save = await this.saveStorageLogger(report);
    await this.saveLogDB(save);

    // const find = await this.findInStorage();
    // if (find === null) {
    //   const save = await this.saveStorageLogger(report);
    //   await this.saveLogDB(save);
    // }
  }

  async findInStorage() {
    const log = await localforage.getItem(this.logName);
    try {
      return log;
    } catch (e) {
      console.log(e);
    }
  }

  async saveStorageLogger(storage) {
    await this.saveLogName(this.logName);
    const log = await localforage.setItem(this.logName, storage);
    try {
      return log;
    } catch (e) {
      console.log(e);
    }
  }

  saveLogDB(db) {
    mutation(this.apollo, db);
  }
}
